<template>
  <!-- `slice` crops like the photo's object-cover, so strokes stay on the spot they were drawn. -->
  <svg
    class="pointer-events-none absolute inset-0 h-full w-full"
    :viewBox="`0 0 ${width} ${height}`"
    preserveAspectRatio="xMidYMid slice"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline
      v-for="(stroke, index) in strokes"
      :key="index"
      :points="toPolylinePoints(stroke.points)"
      :stroke="MARKING_COLORS[stroke.color]"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  getMarkingStrokeWidth,
  MARKING_COLORS,
  toPolylinePoints,
  type MarkingStroke,
} from '@/utils/damage-marking';

/** Strokes of a Damage marking over the photo they were drawn on, in the photo's pixels. */
const props = defineProps<{
  width: number;
  height: number;
  strokes: MarkingStroke[];
}>();

const strokeWidth = computed(() => getMarkingStrokeWidth(props.width, props.height));
</script>
